export default __webpack_public_path__ + "static/media/cinco.d5c713df.jpg";